module.exports = __webpack_public_path__ + "static/media/two_collecting_waves@2x.4dfa54a1.png";